import { Injectable, inject } from '@angular/core';
import { SettingsService } from './../http/settings.service';
import { SettingDao } from './../models/settings/setting-dao.model';
import { SessionStoreService } from './session-store.service';

@Injectable({
  providedIn: 'root',
})
export class UserSettingService {
  private _settingsService = inject(SettingsService);
  private _sessionStoreService = inject(SessionStoreService);

  // Die Einstellungen sind immer geladen, sobald sich der Benutzer eingeloggt hat
  public get settings(): SettingDao | null {
    return this._sessionStoreService.getData<SettingDao>('userSettings');
  }

  public async loadSettings(): Promise<SettingDao> {
    return await this._settingsService.loadUserSettings().then((userSettings) => {
      const userSettingsDao = new SettingDao(userSettings);
      this._sessionStoreService.setData('userSettings', userSettingsDao);
      return userSettingsDao;
    });
  }

  public async saveSettings(userSettings: SettingDao): Promise<any> {
    return await this._settingsService.saveUserSettings(userSettings).then(() => {
      this._sessionStoreService.setData('userSettings', userSettings);
    });
  }
}
